<template>
  <v-list-item ripple class="px-1 py-1" >
    <v-list-item-avatar class="my-0 ml-0 mr-1">
      <v-img
          eager
          :style="{backgroundColor: getBackgroundColor}"
          :src="getImage"
      />
    </v-list-item-avatar>
    <v-list-item-content class="py-0">
      <v-list-item-title>
        {{ item.product.name.charAt(0).toUpperCase() + item.product.name.toLowerCase().substring(1) }}
      </v-list-item-title>
      <v-list-item-subtitle>
        ${{ getPrice(item.product, category) }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action class="ma-0">
      <v-chip class="grey--text text--darken-2 grey lighten-3">{{ item.quantity }}</v-chip>
    </v-list-item-action>
    <v-list-item-action class="ma-0">
      <v-btn x-small icon @click="addProduct()">
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn x-small icon @click="removeProduct()">
        <v-icon>{{ item.quantity === 1 ? 'delete' : 'remove' }}</v-icon>
      </v-btn>
    </v-list-item-action>

  </v-list-item>
</template>

<script>
import ProductMixin from "@/modules/delivery/mixins/ProductMixin";

export default {
  name: "CustomerCartDetailProduct",
  props: {
    item: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    }
  },
  mixins: [ProductMixin],
  computed: {
    getImage() {
        let imageCategory
        if (this.item.product.imageCategory) {
          imageCategory = this.item.product.imageCategory.find(i => i.category === this.category.id)
        }
        return (imageCategory && imageCategory.image) ? imageCategory.image : this.item.product.image
    },
    getBackgroundColor() {
        return this.category.backgroundColor ? this.category.backgroundColor : null
    },
  },
  methods:{
    addProduct() {
      this.$store.commit('addItem', {product: this.item.product, category: this.category})
    },
    removeProduct() {
      this.$store.commit('removeItem', {product: this.item.product, category: this.category})
    }
  }
}
</script>

<style scoped>

</style>
